export const BULK_ADD_INPUT_HINT = 'Add Comma Separated Names, CIN, LLPIN, PAN or GSTIN';
